module.exports = __webpack_public_path__ + "media/dashboard/assets/images/sidebar/user-group-7dd042c02c56aca16e324ac261d50e33.svg";